// src/utils/analytics.js
const GTM_ID = 'GTM-KN9VDXGF';
const GA_ID = 'G-QLXG3ZB8J8';

const injectOnce = (id, build) => {
  if (document.getElementById(id)) return;
  const script = build();
  script.id = id;
  document.head.appendChild(script);
};

// Loads GTM, Google Analytics and the Facebook SDK. Only call this after
// the visitor has given cookie consent (see CookieConsent.jsx).
export const loadTrackingScripts = () => {
  injectOnce('gtm-init', () => {
    const script = document.createElement('script');
    script.textContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${GTM_ID}');`;
    return script;
  });

  injectOnce('ga-src', () => {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    return script;
  });

  injectOnce('ga-init', () => {
    const script = document.createElement('script');
    script.textContent = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${GA_ID}');`;
    return script;
  });

  injectOnce('facebook-sdk', () => {
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.crossOrigin = 'anonymous';
    script.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v12.0';
    return script;
  });
};
